import axios from '@/assets/js/axios'
import Urls from '@/assets/js/Urls'

/**
 * 获取大咖课程列表
 * @param data
 */
export function getAuthorCourseList(data) {
  return axios({
    url: `${Urls.DOMAIN_YKT}/Course/AuthorCourse/List`,
    method: 'post',
    data
  })
    .then(result => {
      return result
    })
    .catch(() => null)
}

/**
 * 大咖端 管理关联视频->课程章节列表
 * @param courseSetId
 */
export function getCourseSectionWithApplies(courseSetId) {
  return axios({
    url: `${Urls.DOMAIN_YKT}/Course/AuthorCourse/GetCourseSectionWithApplies`,
    method: 'post',
    data: {
      courseSetId
    }
  })
    .then(({ result, detail }) => {
      return result.code === 0 ? detail : null
    })
    .catch(() => null)
}

/**
 * 大咖提交课程章节申请
 * @param {{courseSetId:number,sectionNo:number,contentVideoId:string,highlightVideoId:string,sectionName:string}} data
 */
export function submitApply(data) {
  return axios({
    url: `${Urls.DOMAIN_YKT}/Course/AuthorCourse/SubmitApply`,
    method: 'post',
    data
  })
    .then(({ result, detail }) => {
      return result.code === 0 ? detail : null
    })
    .catch(() => null)
}

/**
 * 大咖提交课程章节申请
 */
export function getCourseSections(courseSetId) {
  return axios({
    url: `${Urls.DOMAIN_YKT}/Course/AuthorCourse/GetCourseSections`,
    method: 'post',
    data: {
      courseSetId
    }
  })
    .then(({ result, detail }) => {
      return result.code === 0 ? detail : null
    })
    .catch(() => null)
}

/**
 * 大咖提交创建课程
 */
export function createCourse(data) {
  return axios({
    url: `${Urls.DOMAIN_YKT}/Course/AuthorCourse/AddCourseSet`,
    method: 'post',
    data
  })
    .then(({ result, detail }) => {
      return result.code === 0 ? detail : null
    })
    .catch(() => null)
}
